/*LIBRARY*/
import { useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

import {
  set_value_insight,
  insight_search_admin,
  insight_hirarki_admin,
} from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const AREA_HIRARKI = ({
  auth,
  insight_reducer,
  set_value_insight,
  insight_hirarki_admin,
}) => {
  useEffect(() => {
    //get hirarki provinsi
    insight_hirarki_admin({
      level: "provinsi",
    });
  }, [insight_hirarki_admin]);

  const on_change_general = (e) => {
    const { provinsi, kota } = insight_reducer;

    const value = e.target.value;
    const name = e.target.name;
    set_value_insight({
      key: name,
      value: value,
    });

    if (name === "provinsi") {
      set_value_insight({
        key: "kota",
        value: "",
      });
      set_value_insight({
        key: "kecamatan",
        value: "",
      });
      set_value_insight({
        key: "kelurahan",
        value: "",
      });

      //get hirarki
      insight_hirarki_admin({
        PROVINSI: value,
        level: "kota",
      });
    } else if (name === "kota") {
      set_value_insight({
        key: "kecamatan",
        value: "",
      });
      set_value_insight({
        key: "kelurahan",
        value: "",
      });

      //get hirarki
      insight_hirarki_admin({
        PROVINSI: provinsi,
        KABKOT: value,
        level: "kecamatan",
      });
    } else if (name === "kecamatan") {
      set_value_insight({
        key: "kelurahan",
        value: "",
      });

      //get hirarki
      insight_hirarki_admin({
        PROVINSI: provinsi,
        KABKOT: kota,
        KECAMATAN: value,
        level: "kelurahan",
      });
    } else if (name === "kelurahan") {
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props

  const {
    kelurahan_hirarki,
    kecamatan_hirarki,
    kota_hirarki,
    provinsi_hirarki,
    provinsi,
    kota,
    kecamatan,
    kelurahan,
  } = insight_reducer;

  //content
  return (
    <main>
      <section className="margin_bottom">
        <p className="text_medium sub_color margin_bottom">
          {dict?.["Provinces"]?.[language]}
        </p>
        <select
          id="provinsi"
          name="provinsi"
          value={provinsi}
          onChange={on_change_general}
          data-mapid="selectProvince"
        >
          <option value="" hidden>
            {dict?.["Select provinces"]?.[language]}
          </option>
          {provinsi_hirarki.map((item, idx) => {
            return (
              <option value={item.PROVINSI} key={idx}>
                {item.PROVINSI}
              </option>
            );
          })}
        </select>
      </section>

      {provinsi && (
        <section className="margin_bottom">
          <p className="text_medium sub_color margin_bottom">
            {dict?.["Cities"]?.[language]}
          </p>
          <select
            id="kota"
            name="kota"
            value={kota}
            onChange={on_change_general}
            data-mapid="selectCities"
          >
            <option value="" hidden>
              {dict?.["Select cities"]?.[language]}
            </option>
            {kota_hirarki.map((item, idx) => {
              return (
                <option value={item?.["KABKOT"]} key={idx}>
                  {item?.["KABKOT"]}
                </option>
              );
            })}
          </select>
        </section>
      )}

      {kota && (
        <section className="margin_bottom">
          <p className="text_medium sub_color margin_bottom">
            {dict?.["Sub-district (Kecamatan)"]?.[language]}
          </p>
          <select
            id="kecamatan"
            name="kecamatan"
            value={kecamatan}
            onChange={on_change_general}
            data-mapid="selectSubDistrict"
          >
            <option value="">
              {dict?.["Choose Sub-district (Kecamatan)"]?.[language]}
            </option>
            {kecamatan_hirarki.map((item, idx) => {
              return (
                <option value={item?.["KECAMATAN"]} key={idx}>
                  {item?.["KECAMATAN"]}
                </option>
              );
            })}
          </select>
        </section>
      )}

      {kecamatan && (
        <section className="margin_bottom">
          <p className="text_medium sub_color margin_bottom">
            {dict?.["Village (Desa)"]?.[language]}
          </p>
          <select
            id="kelurahan"
            name="kelurahan"
            value={kelurahan}
            onChange={on_change_general}
            data-mapid="selectDistrict"
          >
            <option value="">
              {dict?.["Choose Village (Desa)"]?.[language]}
            </option>
            {kelurahan_hirarki.map((item, idx) => {
              return (
                <option value={item?.["DESA"]} key={idx}>
                  {item?.["DESA"]}
                </option>
              );
            })}
          </select>
        </section>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  map: state.map,
  properties: state.properties,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  set_value_insight,
  insight_search_admin,
  insight_hirarki_admin,
})(AREA_HIRARKI);
